module.exports = {
  "country": "AM",
  "artist": "Iveta Mukuchyan",
  "song": "LoveWave",
  "year": "2016",
  "place": "7",
  "spotify": "6F3waFskKCqXmiR5gaquey"
};